import React from 'react'
import {
  CircularProgress,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Clear, WatchLaterOutlined } from '@mui/icons-material'
import { UserGroupPolicy } from '../../user-group-policy'
import { ALLOW_HISTORY_EDIT } from '../../user-group-policy/permissions'

const useStyles = makeStyles(({ palette, spacing, typography }) => {
  const textColor = '#212121'

  return {
    searchSuggestionsTitle: {
      cursor: 'default',
      padding: spacing(1, 2),
      '& span': {
        ...typography.body.s,
        fontWeight: typography.fontWeightBold,
        color: textColor
      }
    },
    historyItem: {
      cursor: 'pointer',
      '& .MuiListItemIcon-root': {
        minWidth: 30
      },
      '&:hover, &:focus': {
        background: '#F2F2F2',
        outline: 'none'
      }
    },
    historyAction: {
      '&.MuiIconButton-edgeEnd': {
        marginRight: -12
      }
    },
    historyItemText: {
      color: textColor,
      maxWidth: '90%'
    },
    historyIcon: {
      color: palette.text.secondary
    },
    historyActionIcon: {
      color: palette.text.secondary
    }
  }
})

export const PaidConsumerSearchHistory = ({ history, onSuggestionSelect, onHistoryEdit, isDeleting }) => {
  const classes = useStyles()
  const testAttr = 'paid-consumer-search-history'

  return (
    <>
      <ListItem divider className={classes.searchSuggestionsTitle}>
        <ListItemText
          primaryTypographyProps={{ 'data-test': `${testAttr}-title` }}
        >
          Search History
        </ListItemText>
      </ListItem>
      {history.map((value, idx) => (
        <ListItem
          role='button'
          tabIndex={0}
          aria-label={`Search history: ${value}`}
          disabled={isDeleting}
          component='li'
          onClick={() => onSuggestionSelect(value, 'search-history', idx)}
          divider={idx < history.length - 1}
          key={value}
          className={classes.historyItem}
          data-test={`${testAttr}-item-${idx}`}
        >
          <ListItemIcon>
            <WatchLaterOutlined
              fontSize='small'
              className={classes.historyIcon}
            />
          </ListItemIcon>
          <ListItemText
            primary={value}
            classes={{ primary: classes.historyItemText }}
          />
          <ListItemSecondaryAction>
            <UserGroupPolicy
              accessGroup={ALLOW_HISTORY_EDIT}
              componentAllow={
                <IconButton
                  edge='end'
                  aria-label={`Remove ${value} from search history`}
                  onClick={(e) => {
                    e.stopPropagation() // Prevent triggering the search
                    e.preventDefault() // Prevent any default behavior
                    onHistoryEdit(value)
                  }}
                  onMouseDown={(e) => {
                    e.stopPropagation() // Prevent blur event
                    e.preventDefault() // Keep focus on input to avoid collapse
                  }}
                  className={classes.historyAction}
                  data-test={`${testAttr}-item-${idx}-delete`}
                  disabled={isDeleting}
                  size='large'
                >
                  {
                    (isDeleting)
                      ? (
                        <CircularProgress size={20} color='inherit' />
                        )
                      : (
                        <Clear fontSize='small' className={classes.historyActionIcon} />
                        )
                  }
                </IconButton>
              }
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </>
  )
}
